import { render, staticRenderFns } from "./TableStatusFNS.vue?vue&type=template&id=8a63e6d8&"
import script from "./TableStatusFNS.vue?vue&type=script&lang=ts&"
export * from "./TableStatusFNS.vue?vue&type=script&lang=ts&"
import style0 from "./TableStatusFNS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports